import React, { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import styled from "styled-components";

import IcoMore from "../../styles/images/more.png";
import { useDispatch, useSelector } from "react-redux";
import { getToken } from "../hooks/authFunc";
import { mainActions } from "../../store/slices/mainSlice";
import { checkMobile } from "../hooks/basicFunc";
import { Modal } from "../modal/Modal";
import useDidMountEffect from "../hooks/useDidMountEffect";

const AffiliateList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const modalMsg = useSelector((state) => state.main.modalMsg);
  const data = useSelector((state) => state.main.affiliateIconList);
  const [openModal, setOpenModal] = useState(false);
  useEffect(() => {
    getData();
  }, []);

  const getData = () => {
    const params = {};
    dispatch(mainActions.fetchAffiliateIconList({ params }));
  };

  const userAgent = checkMobile();

  const redirectStore = (li) => {
    //딥링크 없는 경우 로직
    if (userAgent == "other") {
      li.web
        ? window.open(li.web)
        : dispatch(
            mainActions.showMsg({
              msg: `준비중입니다.`,
              type: "",
            })
          );
    } else if (window.confirm("스토어로 이동하시겠습니까?")) {
      if (userAgent == "ios") {
        li.ios
          ? window.open(li.ios)
          : dispatch(
              mainActions.showMsg({
                msg: `준비중입니다.`,
                type: "",
              })
            );
      } else if (userAgent == "android") {
        li.aos
          ? window.open(li.aos)
          : dispatch(
              mainActions.showMsg({
                msg: `준비중입니다.`,
                type: "",
              })
            );
      } else {
        li.web
          ? window.open(li.web)
          : dispatch(
              mainActions.showMsg({
                msg: `준비중입니다.`,
                type: "",
              })
            );
      }
    }
  };
  function exeDeepLink(li) {
    let url = li?.scheme;
    if (url) {
      // let url = "twitter://";
      //if :// 가 있으면 제거하기
      // let url = "kakaomap";
      if (url.includes("://")) {
        url = url.replace("://", "");
      }
      if (window.ReactNativeWebView) {
        const message = { type: "openUrl", content: `${url}` };
        window.ReactNativeWebView.postMessage(JSON.stringify(message));
      }
      window.location.href = `${url}://`;
    }
  }

  function checkInstallApp(li) {
    function clearTimers() {
      clearInterval(check);
      clearTimeout(timer);
    }

    function isHideWeb() {
      //현재 변경 감지 안됨
      if (window.document.webkitHidden || window.document.hidden) {
        clearTimers();
      }
    }
    const check = setInterval(isHideWeb, 200);

    const timer = setTimeout(function () {
      redirectStore(li);
    }, 1000);
  }

  const handleInstallApp = (li) => {
    exeDeepLink();
    checkInstallApp(li);
  };

  useDidMountEffect(() => {
    if (modalMsg.msg) {
      setOpenModal(true);
    }
  }, [modalMsg]);
  return (
    <ListWrap>
      {openModal && (
        <Modal setOpenModal={setOpenModal}>
          <p>{modalMsg.type === "func" ? modalMsg.msg() : modalMsg.msg}</p>
        </Modal>
      )}
      <Ul>
        {data &&
          data.count > 0 &&
          data.list.slice(0, 4).map((li, index) => (
            <li key={index}>
              <LogoWrap
                className="pointer"
                onClick={() => handleInstallApp(li)}
              >
                <img src={li.image} alt="" />
              </LogoWrap>
              <p>{li.title}</p>
            </li>
          ))}
        {data &&
          data.count > 0 &&
          data.list.slice(4, 8).map((li, index) => (
            <li key={index}>
              <LogoWrap
                className="pointer"
                onClick={() => handleInstallApp(li)}
              >
                <img src={li.image} alt="" />
              </LogoWrap>
              <p>{li.title}</p>
            </li>
          ))}
        {data &&
          data.count > 0 &&
          data.list.slice(8, 11).map((li, index) => (
            <li key={index}>
              <LogoWrap
                className="pointer"
                onClick={() => handleInstallApp(li)}
              >
                <img src={li.image} alt="" />
              </LogoWrap>
              <p>{li.title}</p>
            </li>
          ))}
        {data.count >= 11 && (
          <li
            onClick={() => {
              navigate("/introduce/partners/apps");
            }}
          >
            <LogoWrap className="pointer">
              <img src={IcoMore} alt="" />
            </LogoWrap>
            <p>더보기</p>
          </li>
        )}
      </Ul>
    </ListWrap>
  );
};

export default AffiliateList;

const ListWrap = styled.div`
  ul {
    display: flex;
    flex-wrap: wrap;
    margin-top: -1.9rem;
  }
  li {
    margin-top: 1.9rem;
  }
  p {
    color: ${({ theme }) => theme.color.black};
    text-align: center;
    font-family: NanumSquareR;
    font-size: 1.4rem;
    font-weight: 700;
    line-height: normal;
    letter-spacing: -0.42px;
    margin-top: 0.9rem;
  }
`;
const LogoWrap = styled.div`
  border-radius: 10px;
  background: ${({ theme }) => theme.color.white};
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.05);
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Ul = styled.ul`
  padding: 0 2rem 2rem 2rem;
  li {
    width: calc(25% - 1.2rem);
    margin-left: 1.6rem;
    /* background-color: #96b0c9; */
    /* width: 7.2rem; */
    text-align: center;
  }
  :nth-child(1) {
    margin-left: 0;
  }
  :nth-child(5) {
    margin-left: 0;
  }
  :nth-child(9) {
    margin-left: 0;
  }
  display: flex;

  img {
    width: 100%;
    max-width: 100%;
    height: auto;
  }
`;
